import store from '../../../store';
export default function checkIfCanUpdateSuggestion() {
  let scopes = store.getters.userScopes;
  return scopes.includes('suggestions_update');
}
